import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchTohanBooksOrderDataCreatePageLoadResult,
  BatchTohanBooksOrderDataCreatePageLoadResultFromJSON
} from '@/api/models/batch/BatchTohanBooksOrderDataCreatePageLoadResult'
import {
  BatchTohanBooksOrderDataCreateRequest,
  BatchTohanBooksOrderDataCreateRequestToJSON
} from '@/api/models/batch/BatchTohanBooksOrderDataCreateRequest'

export class BatchTohanBooksOrderDataCreateApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTohanBooksOrderDataCreatePageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTohanBooksOrderDataCreatePageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createTohanBooksOrderDataCraeteList(
    request: BatchTohanBooksOrderDataCreateRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/order-accept/tohan-books-order-data-create`,
      BatchTohanBooksOrderDataCreateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
